import { fork, all, call, put, takeLatest, takeEvery, select } from 'redux-saga/effects'

import {
    GET_WISHLIST,
    GET_WISHLIST_SUCCESS,
    GET_WISHLIST_ERROR,
    ADD_TO_WISHLIST,
    ADD_TO_WISHLIST_ERROR,
    ADD_TO_WISHLIST_SUCCESS,
    REMOVE_FROM_WISHLIST,
    REMOVE_FROM_WISHLIST_SUCCESS,
    REMOVE_FROM_WISHLIST_ERROR
} from "../../actions"
import {getToken, getUniversalMenuApiUrls} from "../../selectors"
import {fetchEveJsonData, postEveJsonData} from '../../api'
import forEach from 'lodash/forEach'
import findIndex from 'lodash/findIndex'

function getLocalStorageWishListItems() {
    var item = window.localStorage.getItem("ngStorage-ti_wishlist-items");
    if(!item) return;
    return JSON.parse(item);
}

function removeItemFromLocalStorage(item) {
    var items = getLocalStorageWishListItems();
    if( items )
    {
        var index = findIndex(items, i => i.config_sku === item.config_sku);
        if(index >= 0 )
        {
            items = [
                ...items.slice(0, index),
                ...items.slice(index+1),
            ]
            window.localStorage.setItem("ngStorage-ti_wishlist-items", JSON.stringify( items ));
        }
    }
    notifyLocalStorage();
}

function addItemToLocalStorage(item) {
    var items = getLocalStorageWishListItems();
    if( ! items ) items = [];
    items.push(item);
    window.localStorage.setItem("ngStorage-ti_wishlist-items", JSON.stringify( items ));
    notifyLocalStorage();
}

function notifyLocalStorage()
{
    var items = getLocalStorageWishListItems();
    window.localStorage.setItem("ngStorage-notify_ti_wishlist_update", JSON.stringify({
        status: "updated",
        count: items ? items.length : 0,
        time: new Date().getTime(),
        window_id: Math.floor(Math.random() * 10000) + '_' + new Date().getTime()
    }));
}

function* removeFromWishlist(action) {
    try
    {
        removeItemFromLocalStorage({"config_sku": action.payload.sku});

        try
        {
            const token = yield select(getToken);
            if(token)
            {
                const api = yield select(getUniversalMenuApiUrls);
                yield call(fetchEveJsonData, api.add_to_wishlist + '/' + action.payload.sku, token, 'DELETE' );
            }
        }
        catch (e) {
            console.warn(e)
        }

        yield put({type: REMOVE_FROM_WISHLIST_SUCCESS, payload: action.payload});
        yield put({type: GET_WISHLIST});


    } catch (e) {
        console.error(e);
        yield put({type: REMOVE_FROM_WISHLIST_ERROR, payload: action.payload, message: e.message});
    }
}


export function* removeFromWishlistSaga() {
    yield takeEvery(REMOVE_FROM_WISHLIST, removeFromWishlist);
}

function* addToWishlist(action) {
    try
    {
        addItemToLocalStorage({"config_sku": action.payload.sku});

        const token = yield select(getToken);
        if(token)
        {
            const token = yield select(getToken);
            const api = yield select(getUniversalMenuApiUrls);

            var formData = 'configurable_sku=' + action.payload.sku;
            formData += action.payload.simpleSku ? '&simple_sku=' + action.payload.simpleSku : ''

            yield call(postEveJsonData, api.add_to_wishlist, token, formData);
        }

        yield put({type: ADD_TO_WISHLIST_SUCCESS, payload: action.payload});
        yield put({type: GET_WISHLIST});

    } catch (e) {
        console.error(e);
        yield put({type: ADD_TO_WISHLIST_ERROR, payload: action.payload, message: e.message});
    }
}


export function* addToWishlistSaga() {
    yield takeEvery(ADD_TO_WISHLIST, addToWishlist);
}

function* fetchWishlist(action) {
    try
    {
        var items = getLocalStorageWishListItems();

        var result = {};
        forEach(items, i => {
            result = {
                ...result,
                [i.config_sku]: {state: 'added', sku: i.config_sku}
            }
        })

        yield put({type: GET_WISHLIST_SUCCESS, payload: {
            total_items: items ? items.length : 0,
            wishlistItems: result
        }});

    } catch (e) {
        console.error(e);
        yield put({type: GET_WISHLIST_ERROR, message: e.message});
    }
}

export function* fetchWishlistSaga() {
    yield takeLatest(GET_WISHLIST, fetchWishlist);
}

function* wishListSaga() {
    yield all([
        fork(fetchWishlistSaga),
        fork(addToWishlistSaga),
        fork(removeFromWishlistSaga),
    ])
}

export default wishListSaga;


// WEBPACK FOOTER //
// ./src/sagas/account/wishlist.js